import { render, staticRenderFns } from "./SendVector.vue?vue&type=template&id=4c373214&"
import script from "./SendVector.vue?vue&type=script&lang=js&"
export * from "./SendVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports